import { Users } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function UsersSettingsPage() {
  return (
    <PlaceholderPage
      icon={Users}
      title="U\u017Cytkownicy"
      description="Zarz\u0105dzaj u\u017Cytkownikami systemu, zapraszaj nowych cz\u0142onk\u00F3w zespo\u0142u i edytuj ich role."
    />
  )
}
